import React, { useEffect } from "react";
import { Button, Col, Container, Row } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { useAuth } from "hooks/auth";
import { HERO } from "lib/routes";
import img1 from "assets/home.png";

const Home = () => {
  const history = useNavigate();
  const { user, isLoading } = useAuth();

  useEffect(() => {
    if (!isLoading && user) {
      console.log("🔄 User already logged in, redirecting to dashboard");
      history(HERO);
    }
  }, [user, isLoading, history]);

  const handleLogin = () => {
    try {
       
      history("/login");
    } catch (error) {
       
      console.error("Navigation error:", error);
    }
  };

  

  return (
    <Container fluid
      className="d-flex align-items-center justify-content-center max-vh-100"
      style={{ minHeight: "100vh", backgroundColor:"#f37a2f" ,fontFamily: "'Montserrat', sans-serif"}}
    >
      <Row className="justify-content-center">
        
        <Col md={6} className="mb-4 ">
          <h2 className="mb-4 text-light text-center" style={{fontSize:"35px"}}><b>Welcome to Hunger Free</b></h2>
          <p className="mb-4 text-center text-light" style={{fontSize:"20px"  }}>Start your helping journey with us.</p>
          <img src={img1} alt="Welcome" className="img-fluid" />
          <br></br>
          <div style={{textAlign:"center"}}>
            <Button
              variant="secondary"
              className="me-2"
              onClick={handleLogin}
              aria-label="Login"
              style={{padding:"12px"}}
            >
              <b>Get Started</b>
            </Button>
          </div>
        </Col>
      </Row>
    </Container>
    
  );
};

export default Home;